import type { SkiAreaReviewType } from "../../network/matlocq/types/skiArea";

const reviewIconMap: Record<SkiAreaReviewType, string> = {
    apres: "snow-icon-apres-ski",
    beginner: "snow-icon-newbie",
    families: "snow-icon-family2",
    freeride: "snow-icon-freeride",
    freestyle: "snow-icon-freestyle",
    onMountainDining: "snow-icon-house",
    snow: "snow-icon-snow",
};

export default reviewIconMap;
